import { useQuery } from '@tanstack/react-query';
import { apiListRisks } from '../api/risks.api';

export function useRisks(projectId: string, params?: { includeClosed?: boolean; category?: string | null }) {
    return useQuery({
        queryKey: ['risks', projectId, params],
        queryFn: () =>
            apiListRisks(projectId, {
                includeClosed: !!params?.includeClosed,
                category: params?.category ?? undefined,
            }),
    });
}
